'use strict';
'use es6';

/**
 * @param {any} key
 * @return {boolean} `true` if this is a valid `WeakMap` key, `false` otherwise
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isObject = function isObject(key) {
  return (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' && key != null || typeof key === 'function';
};

/**
 * @param {Object} object
 * @return {boolean} `true` if this is an Immutable-style object with `hashCode()` and `equals()`
 */
var isHashable = function isHashable(object) {
  return typeof object.hashCode === 'function' && typeof object.equals === 'function';
};

/**
 * @param {string|number|boolean|symbol} primitive
 * @return {string|symbol} An object key that's unique to this primitive
 */
var primitiveKey = function primitiveKey(primitive) {
  return (typeof primitive === 'undefined' ? 'undefined' : _typeof(primitive)) === 'symbol' ? primitive : (typeof primitive === 'undefined' ? 'undefined' : _typeof(primitive)) + '-' + primitive;
};

/**
 * A `CacheLayer` may contain any mix of:
 * 1. A value (`getValue()`)
 * 2. Nested layers (`get(key)`)
 */

var CacheLayer = exports.CacheLayer = function () {
  function CacheLayer() {
    _classCallCheck(this, CacheLayer);

    this.objectCache = null;
    this.hashableCache = null;
    this.primitiveCache = null;
    this.value = null;
  }

  /**
   * @param {any} key
   * @returns {CacheLayer|null}
   */


  _createClass(CacheLayer, [{
    key: 'get',
    value: function get(key) {
      if (isObject(key)) {
        if (isHashable(key) && this.hashableCache) {
          var hashableCacheResult = this.hashableCache[key.hashCode()];
          if (hashableCacheResult && key.equals(hashableCacheResult[0])) {
            return hashableCacheResult[1];
          }
        }
        return this.objectCache && this.objectCache.get(key);
      }
      return this.primitiveCache && this.primitiveCache[primitiveKey(key)];
    }

    /**
     * @param {any} key
     * @param {CacheLayer} cacheLayer
     */

  }, {
    key: 'set',
    value: function set(key, cacheLayer) {
      if (isObject(key)) {
        if (isHashable(key)) {
          if (!this.hashableCache) this.hashableCache = Object.create(null);
          this.hashableCache[key.hashCode()] = [key, cacheLayer];
        }
        if (!this.objectCache) this.objectCache = new WeakMap();
        this.objectCache.set(key, cacheLayer);
        return;
      }
      if (!this.primitiveCache) this.primitiveCache = Object.create(null);
      this.primitiveCache[primitiveKey(key)] = cacheLayer;
    }

    /**
     * @returns {any}
     */

  }, {
    key: 'getValue',
    value: function getValue() {
      return this.value;
    }

    /**
     * @param {any} value
     */

  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.value = value;
    }
  }]);

  return CacheLayer;
}();

/**
 * Retrieves a value from a layered cache, if that value exists.
 * @param {CacheLayer} cacheLayer
 * @param {...any} nestedKeys
 * @return {any}
 */


var cacheGet = exports.cacheGet = function cacheGet(cacheLayer, nestedKeys) {
  var layer = cacheLayer;
  for (var i = 0; i < nestedKeys.length; i++) {
    if (!layer) return null;
    var nextLayer = layer.get(nestedKeys[i]);
    layer = nextLayer;
  }
  return layer && layer.getValue();
};

/**
 * Inserts a value into a layered cache.
 * @param {CacheLayer} cacheLayer
 * @param {...any} nestedKeys
 * @param {any} value
 */
var cachePut = exports.cachePut = function cachePut(cacheLayer, nestedKeys, value) {
  var layer = cacheLayer;
  nestedKeys.forEach(function (key) {
    var nextLayer = layer.get(key);
    if (!nextLayer) {
      nextLayer = new CacheLayer();
      layer.set(key, nextLayer);
    }
    layer = nextLayer;
  });
  layer.setValue(value);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/core/internal/LayeredCache.js
// module id = 592
// module chunks = 171